import { Injectable } from '@angular/core';
import { CanActivate, UrlTree, Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { PermissionsHttpService } from 'src/app/shared/permissions-http-service/permissions-http.service';
import { map, catchError } from 'rxjs/operators';
import * as _ from 'lodash';
import { availableFeatures } from 'src/environments/environment';
import { Features } from 'src/environments/features';
@Injectable({ providedIn: 'root' })
export class KnowledgeSearchAuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private permissions: PermissionsHttpService
  ) { }

  canActivate():
    | boolean
    | UrlTree
    | Promise<boolean | UrlTree>
    | Observable<boolean | UrlTree> {
    return this.permissions
      .checkPermission({ permissions: { accessLittResearch: {} } })
      .pipe(
        map((res) => {
          if ((res.accessLittResearch &&  _.includes(availableFeatures, Features.KnowledgeSearch))) {
            return true;
          } else {
            return this.router.createUrlTree(['/']);
          }
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }
}
